import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "shape-rendering": "geometricPrecision",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.275 13.859a.62.62 0 0 1-.442-.184.63.63 0 0 1 0-.883l9.958-9.958a.63.63 0 0 1 .884 0 .63.63 0 0 1 0 .883l-9.959 9.967a.63.63 0 0 1-.441.175m5.975 1.998a.62.62 0 0 1-.442-.183.63.63 0 0 1 0-.883l1-1a.63.63 0 0 1 .883 0 .63.63 0 0 1 0 .883l-1 1a.63.63 0 0 1-.441.183",
  "clip-rule": "evenodd"
}, null, -1), t = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M11.492 13.119a.1.1 0 0 1-.047-.01.12.12 0 0 1-.076-.116q.001-.054.034-.088l1.992-1.991a.12.12 0 0 1 .088-.035q.055.001.088.035l.354-.354-.354.354a.12.12 0 0 1 .035.088.12.12 0 0 1-.035.088l-1.991 1.992a.14.14 0 0 1-.088.036Z",
  "vector-effect": "non-scaling-stroke"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.25 18.96c-.817 0-1.633-.5-2.625-1.492l-4.092-4.092C.542 11.384.55 10.101 2.558 8.093l5.534-5.534C10.1.551 11.383.543 13.375 2.534l4.092 4.092c1.991 1.992 1.983 3.275-.025 5.283l-5.534 5.534c-1.008 1.008-1.833 1.516-2.658 1.516m1.5-16.667c-.433 0-.983.358-1.775 1.15L3.442 8.976c-.792.792-1.15 1.342-1.15 1.767 0 .433.333.958 1.125 1.75l4.091 4.091c.792.792 1.309 1.125 1.742 1.125h.008c.434 0 .975-.358 1.767-1.15l5.533-5.533c.792-.792 1.15-1.342 1.15-1.767 0-.433-.333-.958-1.125-1.75l-4.091-4.091c-.784-.792-1.309-1.125-1.742-1.125",
  "clip-rule": "evenodd"
}, null, -1), d = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.333 18.957H1.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h16.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625",
  "clip-rule": "evenodd"
}, null, -1), i = [
  n,
  t,
  c,
  d
];
function a(s, u) {
  return l(), o("svg", r, [...i]);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
